"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Slider = _interopRequireDefault(require("./Slider"));
var _useQuestionSelectionActions = require("../../hooks/questionnaire/useQuestionSelectionActions");
var _RangePicker = _interopRequireDefault(require("./RangePicker/RangePicker"));
var _constants = require("../../utils/constants");
var _services = require("../../services");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
var _useAppDispatch = require("../../hooks/useAppDispatch");
var _useAppSelector = require("../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const getSliderProps = (question, selection, lastSelectedBudget) => {
  const {
    rangeTitle,
    rangeSubTitle,
    rangeChoices
  } = question;
  const {
    min,
    max,
    step,
    minLabel,
    maxLabel,
    defaultValue
  } = rangeChoices;
  let value = selection || defaultValue || min;
  if (_constants.BUDGET_QUESTION_IDS.includes(question === null || question === void 0 ? void 0 : question.id)) {
    value = lastSelectedBudget || value;
  }
  const title = rangeTitle.replace('{{value}}', value).replace('{{currencyValue}}', _services.locale.formatPrice(value, {
    fraction: false
  }));
  const subtitle = rangeSubTitle;
  let labels = rangeChoices.labels;
  if (!labels) {
    labels = [{
      value: min,
      label: minLabel
    }, {
      value: max,
      label: maxLabel
    }];
    for (let i = min + step; i <= max - step; i += step) {
      labels.push({
        value: i,
        label: i
      });
    }
    labels.sort((l1, l2) => {
      return l1.value - l2.value;
    });
  }
  return {
    title,
    subtitle,
    value,
    min,
    max,
    step,
    labels
  };
};
const QuestionWithRange = _ref => {
  let {
    question,
    onUpdate,
    selections = [],
    selectionIndex = 0,
    componentIndex,
    defaultSelection
  } = _ref;
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    lastSelectedBudget,
    lastSelectedPlanBudget
  } = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectBudget);
  const selectedBudgetForProductType = (0, _questionnaireUtil.getQuestionProductType)(question) === _constants.PRODUCT_TYPES.HANDSET ? lastSelectedBudget : lastSelectedPlanBudget;
  const rangeProps = getSliderProps(question, selections[selectionIndex], selectedBudgetForProductType);
  const {
    replaceSelection
  } = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question);
  const onChangeValue = selection => {
    replaceSelection(selection, selectionIndex);
    if (typeof onUpdate === 'function') {
      onUpdate(selection, question);
    }
  };
  (0, _react.useEffect)(() => {
    if (selections.length === 0 && question.viewType !== _constants.QUESTION_VIEW_TYPE.CHOICES) {
      replaceSelection(rangeProps.value, selectionIndex);
    }
    if ((question === null || question === void 0 ? void 0 : question.id) === _constants.QUESTION_ID.NUM_OF_PLANS) {
      selections.length === 0 ? dispatch((0, _recommendationActions.setAdditionalPlans)(rangeProps.value)) : dispatch((0, _recommendationActions.setAdditionalPlans)(selections[0]));
    }
  }, []);
  const handleOnChange = value => {
    if ((question === null || question === void 0 ? void 0 : question.id) === _constants.QUESTION_ID.NUM_OF_PLANS) {
      dispatch((0, _recommendationActions.setAdditionalPlans)(value));
    }
    onChangeValue(value);
  };
  const idPrefix = componentIndex !== undefined ? `set-${componentIndex}-` : '';
  const icon = question.rangeIcon;
  const imageSrc = question.rangeImageSource;
  switch (question.viewType) {
    case _constants.QUESTION_VIEW_TYPE.CHOICES:
      return /*#__PURE__*/_react.default.createElement(_RangePicker.default, {
        src: imageSrc,
        icon: icon,
        onChangeValue: handleOnChange,
        choices: rangeProps.labels,
        title: rangeProps.title,
        selection: selections[selectionIndex],
        idPrefix: idPrefix,
        type: question.viewAs === 'slider' ? 'sliderPicker' : 'default',
        sliderStyle: {
          border: !!question.sliderStyle && question.sliderStyle === _constants.SLIDER_STYLES.BORDERED,
          appearance: question.sliderAppearance
        },
        dataAttributes: {
          'data-test-id': 'range-picker-id'
        }
      });
    default:
      return /*#__PURE__*/_react.default.createElement(_Slider.default, _extends({}, rangeProps, {
        src: imageSrc,
        icon: icon,
        onChangeValue: handleOnChange,
        idPrefix: idPrefix,
        showPriceOnToolTip: question.showPriceOnToolTip,
        showSubtitleOnChange: question.showSubtitleOnChange,
        sliderStyle: {
          border: !!question.sliderStyle && question.sliderStyle === _constants.SLIDER_STYLES.BORDERED
        },
        defaultSelection: defaultSelection,
        id: "range-slider-id"
      }));
  }
};
var _default = QuestionWithRange;
exports.default = _default;